import { Eye } from 'lucide-react';

export const UploadImageAnalysisOption = ({ analyzeImages, onToggle }) => (
  <div className="flex items-center gap-3 rounded-sm border border-zinc-800 bg-zinc-900/50 p-3">
    <input
      type="checkbox"
      id="analyzeImages"
      data-testid="analyze-images-checkbox"
      checked={analyzeImages}
      onChange={(event) => onToggle(event.target.checked)}
      className="h-4 w-4 accent-white"
    />
    <label htmlFor="analyzeImages" className="flex-1 cursor-pointer">
      <div className="flex items-center gap-2 text-sm text-white">
        <Eye className="h-4 w-4" />
        <span>Analyser les images (captures d'écran)</span>
      </div>
      <p className="mt-1 text-xs text-zinc-500">
        Utilise l'IA pour extraire le contenu des images dans le PDF
      </p>
    </label>
  </div>
);
